<template>
  <v-card outlined>
    <line-chart
      title="Sessions et CA"
      :colors="colors"
      :series="series"
      :labels="labels"
      :yAxis="yAxis"
      :xAxis="xAxis"
      :stroke="stroke"
      outlined
    ></line-chart>
  </v-card>
</template>

<script>
import { computed } from "@vue/composition-api";

import LineChart from "@/components/common/charts/LineChart";

import { colors } from "@/utils/constants";
import { formatCurrency, formatNumber } from "@/utils/formatting";

const yAxis = (formatter, color = "") => ({
  min: 0,
  forceNiceScale: true,
  labels: {
    formatter,
    style: {
      fontSize: "12px",
      fontWeight: 400,
      ...(color ? { colors: color } : {}),
    },
  },
});

export default {
  name: "GaStatsByDateChart",
  components: {
    LineChart,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {

    // =>  METHODS

    // =>  COMPUTED
    const labels = computed(() => props.data.map(item => item.date));
    const series = computed(() => ([
          // Order must be the same than in chartOptions.yaxis definition
          {
            name: "sessions",
            type: "line",
            data: props.data.map(item => item.sessions),
          },
          {
            name: "ca",
            type: "column",
            data: props.data.map(item => item.ca),
          },
        ]));

    // =>  WATCH

    // =>  HOOKS

    // =>  DATA
    return {
      colors: [colors.sessions, colors.ca],
      series,
      labels,
      yAxis: [
        // Order must be the same than in series definitions
        {
          seriesName: "sessions",
          title: {
            text: "Sessions",
            style: { color: colors.sessions },
          },
          ...yAxis((value) => formatNumber(value), colors.sessions),
        },
        {
          opposite: true,
          seriesName: "ca",
          title: {
            text: "CA",
            style: { color: colors.ca },
          },
          ...yAxis((value) => formatCurrency(value), colors.ca),
        },
      ],
      // Le graphe est rendu en `type: "line"` : ApexCharts convertirait l'axe de
      // categories en axe numerique, et la largeur des barres de CA, derivee du
      // ratio numerique, s'effondre des que les jours s'accumulent (invisible sur
      // 6 mois). `tickPlacement: "between"` est la seule condition qui empeche
      // cette conversion, cf. Config.js convertCatToNumeric.
      xAxis: {
        type: "category",
        categories: [],
        tickPlacement: "between",
        labels: {
          rotate: -45,
          rotateAlways: true,
        },
        style: {
          fontSize: "12px",
          fontWeight: 400,
        },
      },
      stroke: {
        show: true,
        curve: "smooth",
        // 0 sur la serie CA : un contour de 2 px est centre sur le bord de la
        // barre, donc il en ronge 1 px de chaque cote. Sans effet sur une barre
        // large, il la fait disparaitre quand elle ne fait que quelques pixels.
        width: [2, 0],
      },
    };
  },
};
</script>
